import InvestmentPlan from "../components/InvestmentPlan"; 
import DashboardHeader from "../components/DashboardHeader.jsx";
import Footer from "../components/Footer.jsx"; 
import SubHero from "../components/SubHero.jsx"; 
const  ChooseInvestmentPlan = ()=>{
    return (
        <>
        <DashboardHeader />
        <div className = "grid grid-cols-1 gap-6 mt-10 sm:mt-20">
            <SubHero imgUrl = {{backgroundImage:'url("https://i.ibb.co/LxwYRqF/trade-jpg.jpg")'}} section = {"All investment plan"} name = {"investment plan"} destination = {"dashboard"}/>
             <InvestmentPlan toDeposit = {true} />
            <Footer />
        </div>
        </>
    ); 
}
export default ChooseInvestmentPlan; 
